import Api from "../api";
import { InstanceGroup, InstanceGroupDto, InstanceGroupInstance } from "@/services/instances/types";

export async function getAllInstanceGroups(): Promise<Array<InstanceGroup>> {
    return new Promise((resolve, reject) => {
        Api.get("/instancegroup").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getInstanceGroupById(id: string): Promise<InstanceGroupDto> {
    return new Promise((resolve, reject) => {
        Api.get(`/instancegroup/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function createInstanceGroup(model: InstanceGroupDto): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/instancegroup", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function updateInstanceGroup(model: InstanceGroupDto): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/instancegroup", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function deleteInstanceGroup(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/instancegroup/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getInstanceGroupInstances(id: string): Promise<Array<InstanceGroupInstance>> {
    return new Promise((resolve, reject) => {
        Api.get(`/instancegroup/instances/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
